import MarketingMenu from './MarketingMenu';

export default MarketingMenu;
